import { PRIVACY_CENTER_MODULE_CONTEXT_MAP } from '../constants';
import type { PrivacyCenterModule } from '../types';

/**
 * gets the s3 key for the specified privacy center module
 *
 * @param privacyCenterUrl - the url of the privacy center
 * @param moduleName - the module to deploy
 * @param locale - the current locale (if applicable)
 * @returns the s3 key for the static module
 */
export function getPrivacyCenterModuleS3Key(
  privacyCenterUrl: string,
  moduleName: PrivacyCenterModule,
  locale?: string,
): string {
  const localeSuffix = locale ? `-${locale}` : '';
  // remove protocol from the key
  const pcHost = new URL(privacyCenterUrl).host;
  const moduleWithSuffix =
    PRIVACY_CENTER_MODULE_CONTEXT_MAP[moduleName].moduleFilename + localeSuffix;

  return `static/${pcHost}/${moduleWithSuffix}.json`;
}
